// extracted by mini-css-extract-plugin
export default {"root":"Tab_root__OkbPU","button":"Tab_button__KopLo","active":"Tab_active__uRYAU","text":"Tab_text__mvr4l","buttonInner":"Tab_buttonInner__BY4Cq","icon":"Tab_icon__lGQ6v"};